function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

import { isFunction } from 'lodash';

var Filters = function () {
  function Filters() {
    _classCallCheck(this, Filters);

    this.filtersObj = {};
  }

  Filters.prototype.andFilter = function andFilter(name, fn) {
    var toggle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (toggle) {
      if (!!this.filtersObj[name]) {
        this.removeAndFilter(name);
      } else {
        this.filtersObj[name] = fn;
      }
    } else {
      this.filtersObj[name] = fn;
    }

    return this;
  };

  Filters.prototype.orFilter = function orFilter(groupName, name, fn) {
    var toggle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    if (!this.filtersObj[groupName]) {
      this.filtersObj[groupName] = {};
    }

    if (toggle) {
      if (!!this.filtersObj[groupName][name]) {
        this.removeOrFilter(groupName, name);
      } else {
        this.filtersObj[groupName][name] = fn;
      }
    } else {
      this.filtersObj[groupName][name] = fn;
    }

    return this;
  };

  Filters.prototype.removeAndFilter = function removeAndFilter(name) {
    delete this.filtersObj[name];
    return this;
  };

  Filters.prototype.removeOrFilter = function removeOrFilter(groupName, name) {
    if (!!this.filtersObj[groupName] && !!this.filtersObj[groupName][name]) {
      delete this.filtersObj[groupName][name];

      if (Object.keys(this.filtersObj[groupName]).length === 0) {
        delete this.filtersObj[groupName];
      }
    }

    return this;
  };

  Filters.prototype.getFilters = function getFilters() {
    return this.filtersObj;
  };

  Filters.prototype.filterFn = function filterFn() {
    var evaluateOrObj = function evaluateOrObj(orObj) {
      return function (element) {
        return Object.values(orObj).reduce(function (partial, fn, index) {
          return index === 0 ? false || fn.apply(null, [element]) : partial || fn.apply(null, [element]);
        }, true);
      };
    };

    var fnsAnd = Object.values(this.filtersObj).filter(function (filterobj) {
      return isFunction(filterobj);
    });
    var fnsOr = Object.values(this.filtersObj).filter(function (filterobj) {
      return !isFunction(filterobj);
    });
    return function (element) {
      return fnsAnd.reduce(function (partial, fn) {
        return partial && fn.apply(null, [element]);
      }, true) && fnsOr.reduce(function (partial, orObj) {
        return partial && evaluateOrObj(orObj)(element);
      }, true);
    };
  };

  Filters.prototype.reset = function reset() {
    this.filtersObj = {};
    return this;
  };

  return Filters;
}();

export default Filters;